/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from 'react';
import PaymentsAPI from 'api/PaymentsAPI';
import CircularProgress from '@mui/material/CircularProgress';
import RenewPlanModal from './RenewPlanModal';
import ConfirmDowngradeModal from './ConfirmDowngradeModal';
import { Modal } from '@mui/material';
import SubMgmtModal from './SubMgmtModal';
import PayMethodOptionsModal from './PayMethodOptionsModal';
import CreatePaymentModal from './CreatePaymentModal';
import
{
  standardMeterPriceGroup,
  standardMeterPriceGroupAnnual,
  proMeterPriceGroup,
  proMeterPriceGroupAnnual,
  entMeterPriceGroup,
  entMeterPriceGroupAnnual
} from 'utils/meterPriceGroups';
import DowngradeNotice from './DowngradeNotice';

interface IPlanManagement {
  cusObj: any;
  cusId: string;
  team: any;
  planState: any;
  newPlan: string;
  currentPlan: any;
  setCurrentPlan: any;
  cur_user: any;
  activeBtn: string;
  quantity: number;
  subInfo: any;
  handleTabChange: any;
}

const PlanManagement: React.FC<IPlanManagement> = ({
  cur_user,
  currentPlan,
  setCurrentPlan,
  newPlan,
  planState,
  team,
  cusId,
  cusObj,
  activeBtn,
  quantity,
  subInfo,
  handleTabChange
}) => {
  const [ planChanged, setPlanChanged ] = useState(false);
  const [ incomingChanges, setIncomingChanges ] = useState<any>({ isLoading: true, data: {} });
  const [ downgrade, setDowngrade ] = useState<boolean>(false);
  const [ confirmMode, setConfirmMode ] = useState<boolean>(false);
  const [ mgmtOpen, setMgmtOpen ] = useState({ open: false, action: 'update' });
  const [ renewMode, setRenewMode ] = useState<boolean>(false);
  const [ payMode, setPayMode ] = useState<boolean>(false);
  const [ createMode, setCreateMode ] = useState<boolean>(false);
  const [ planUpdating, setPlanUpdating ] = useState(false);
  const [ curPaymentMethod, setCurPaymentMethod ] = useState<any>({ isLoading: true, data: {} });
  const [ methods, setMethods ] = useState<any>({ isLoading: true, data: [] });
  const [ paymentSubmit, setPaymentSubmit ] = useState<string>('');

  const standardMonthlyPrice = process.env.REACT_APP_BITE_STANDARD_MONTHLY!;
  const standardAnnualPrice = process.env.REACT_APP_BITE_STANDARD_ANNUAL!;
  const standardPeoplePrice = process.env.REACT_APP_BITE_STANDARD_PEOPLE!;
  const standardProductsPrice = process.env.REACT_APP_BITE_STANDARD_PRODUCTS!;
  const standardFormsPrice = process.env.REACT_APP_BITE_STANDARD_FORMS!;
  const standardPeoplePriceAnnual = process.env.REACT_APP_BITE_STANDARD_PEOPLE_ANNUAL!;
  const standardProductsPriceAnnual = process.env.REACT_APP_BITE_STANDARD_PRODUCTS_ANNUAL!;
  const standardFormsPriceAnnual = process.env.REACT_APP_BITE_STANDARD_FORMS_ANNUAL!;

  const proMonthlyPrice = process.env.REACT_APP_BITE_PRO_MONTHLY!;
  const proAnnualPrice = process.env.REACT_APP_BITE_PRO_ANNUAL!;
  const proPeoplePrice = process.env.REACT_APP_BITE_PRO_PEOPLE!;
  const proProductsPrice = process.env.REACT_APP_BITE_PRO_PRODUCTS!;
  const proFormsPrice = process.env.REACT_APP_BITE_PRO_FORMS!;
  const proPeoplePriceAnnual = process.env.REACT_APP_BITE_PRO_PEOPLE_ANNUAL!;
  const proProductsPriceAnnual = process.env.REACT_APP_BITE_PRO_PRODUCTS_ANNUAL!;
  const proFormsPriceAnnual = process.env.REACT_APP_BITE_PRO_FORMS_ANNUAL!;

  const entMonthlyPrice = process.env.REACT_APP_BITE_ENT_MONTHLY!;
  const entAnnualPrice = process.env.REACT_APP_BITE_ENT_ANNUAL!;
  const entPeoplePrice = process.env.REACT_APP_BITE_ENT_PEOPLE!;
  const entProductsPrice = process.env.REACT_APP_BITE_ENT_PRODUCTS!;
  const entFormsPrice = process.env.REACT_APP_BITE_ENT_FORMS!;
  const entPeoplePriceAnnual = process.env.REACT_APP_BITE_ENT_PEOPLE_ANNUAL!;
  const entProductsPriceAnnual = process.env.REACT_APP_BITE_ENT_PRODUCTS_ANNUAL!;
  const entFormsPriceAnnual = process.env.REACT_APP_BITE_ENT_FORMS_ANNUAL!;

  const changePlan = async(subUpdates: any) => {
    setPlanUpdating(true);
    let metadata = {};
    let meterPriceGroup: any = {};
    if (newPlan === 'Standard') {
      metadata = {
        moduleName: 'BITE Standard',
        type: 'fixed'
      };
      meterPriceGroup = activeBtn === 'monthly' ? standardMeterPriceGroup : standardMeterPriceGroupAnnual;
      meterPriceGroup.people.id = subUpdates.peopleItemId;
      meterPriceGroup.products.id = subUpdates.productsItemId;
      meterPriceGroup.forms.id = subUpdates.formsItemId;
    }
    if (newPlan === 'Pro') {
      metadata = {
        moduleName: 'BITE Pro',
        type: 'fixed'
      };
      meterPriceGroup = activeBtn === 'monthly' ? proMeterPriceGroup : proMeterPriceGroupAnnual;
      meterPriceGroup.people.id = subUpdates.peopleItemId;
      meterPriceGroup.products.id = subUpdates.productsItemId;
      meterPriceGroup.forms.id = subUpdates.formsItemId;
    }
    if (newPlan === 'Enterprise') {
      metadata = {
        moduleName: 'BITE Enterprise',
        type: 'fixed'
      };
      meterPriceGroup = activeBtn === 'monthly' ? entMeterPriceGroup : entMeterPriceGroupAnnual;
      meterPriceGroup.people.id = subUpdates.peopleItemId;
      meterPriceGroup.products.id = subUpdates.productsItemId;
      meterPriceGroup.forms.id = subUpdates.formsItemId;
    }
    subUpdates.metadata = metadata;
    subUpdates.meterPriceGroup = meterPriceGroup;
    const updatedSubscription = await PaymentsAPI.changePlan(subUpdates);
    if (updatedSubscription?.success) {
      setPlanUpdating(false);
      history.go(0);
    }
  };

  const createSubscription = async(cus_id: string, pay_method: string, tier: string, freeTrialStatus: boolean) => {
    setPlanUpdating(true);
    const standardObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? standardMonthlyPrice : standardAnnualPrice,
          quantity: quantity,
          metadata: {
            type: 'fixed',
            moduleName: 'BITE Standard'
          }
        },
        // Prices for tracking screening usage with attached meters
        {
          price: activeBtn === 'monthly' ? standardPeoplePrice : standardPeoplePriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'People'
          }
        },
        {
          price: activeBtn === 'monthly' ? standardProductsPrice : standardProductsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Products'
          }
        },
        {
          price: activeBtn === 'monthly' ? standardFormsPrice : standardFormsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Forms'
          }
        }
      ],
      metadata: {
        freeTrial: false,
        freeTrialDays: 0,
        team_id: team.id,
        keycloakUserId: cur_user?.basics?.id,
        moduleName: 'BITE Standard',
        activeSub: subInfo?.id ? subInfo?.id : '',
        activeSubStatus: subInfo?.status ? subInfo?.status : ''
      }
    };
    const proObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? proMonthlyPrice : proAnnualPrice,
          quantity: freeTrialStatus ? 1 : quantity,
          metadata: {
            type: 'fixed',
            moduleName: 'BITE Pro'
          }
        },
        // Prices for tracking screening usage with attached meters
        {
          price: activeBtn === 'monthly' ? proPeoplePrice : proPeoplePriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'People'
          }
        },
        {
          price: activeBtn === 'monthly' ? proProductsPrice : proProductsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Products'
          }
        },
        {
          price: activeBtn === 'monthly' ? proFormsPrice : proFormsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Forms'
          }
        }
      ],
      metadata: {
        freeTrial: freeTrialStatus,
        team_id: team.id,
        freeTrialDays: 0,
        keycloakUserId: cur_user?.basics?.id,
        moduleName: 'BITE Pro',
        activeSub: subInfo?.id ? subInfo?.id : '',
        activeSubStatus: subInfo?.status ? subInfo?.status : ''
      }
    };
    const entObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? entMonthlyPrice : entAnnualPrice,
          quantity: quantity,
          metadata: {
            type: 'fixed',
            moduleName: 'BITE Enterprise'
          }
        },
        // Prices for tracking screening usage with attached meters
        {
          price: activeBtn === 'monthly' ? entPeoplePrice : entPeoplePriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'People'
          }
        },
        {
          price: activeBtn === 'monthly' ? entProductsPrice : entProductsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Products'
          }
        },
        {
          price: activeBtn === 'monthly' ? entFormsPrice : entFormsPriceAnnual,
          metadata: {
            type: 'meter',
            moduleName: 'Forms'
          }
        }
      ],
      metadata: {
        freeTrial: false,
        freeTrialDays: 0,
        team_id: team.id,
        keycloakUserId: cur_user?.basics?.id,
        moduleName: 'BITE Enterprise',
        activeSub: subInfo?.id ? subInfo?.id : '',
        activeSubStatus: subInfo?.status ? subInfo?.status : ''
      }
    };
    if (tier === 'Standard') {
      const created = await PaymentsAPI.createSubscription(
        cus_id,
        standardObj,
        pay_method
      );
      if (created?.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'Pro') {
      const created = await PaymentsAPI.createSubscription(
        cus_id,
        proObj,
        pay_method
      );
      if (created?.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'Enterprise') {
      const created = await PaymentsAPI.createSubscription(
        cus_id,
        entObj,
        pay_method
      );
      if (created?.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
  };

  const previewPayment = async(cus_id: string, price_id: string, quantity: any, sub_id?: string) => {
    setIncomingChanges({ isLoading: true, data: {} });
    if (incomingChanges.isLoading) {
      if (sub_id) {
        const subChange = await PaymentsAPI.previewSubPayment(
          sub_id,
          cus_id,
          price_id,
          quantity
        );
        if (subChange?.success) {
          setIncomingChanges({ isLoading: false, data: subChange?.result });
        }
      }
      if (!sub_id) {
        const subChange = await PaymentsAPI.previewCheckout(
          cus_id,
          price_id,
          quantity
        );
        if (subChange?.success) {
          setIncomingChanges({ isLoading: false, data: subChange?.result });
        }
      }
    }
  };

  const getCurPaymentMethod = async(pay_id: string) => {
    const method = await PaymentsAPI.getPaymentMethodById(cusId, pay_id);
    if (method?.success) {
      setCurPaymentMethod({ isLoading: false, data: method?.result });
    }
  };

  const getCusPaymentMethods = async(cus_id: string) => {
    const payMethods = await PaymentsAPI.getCustomerPaymentMethods(cus_id);
    if (payMethods?.success) {
      setMethods({ isLoading: false, data: payMethods?.result });
    }
  };

  useEffect(() => {
    if (cusObj?.data?.invoice_settings?.default_payment_method !== null) {
      getCurPaymentMethod(cusObj?.data?.invoice_settings?.default_payment_method);
    } else if (paymentSubmit.length > 0) {
      getCurPaymentMethod(paymentSubmit);
    }
    getCusPaymentMethods(cusId);
  }, [ cusId, paymentSubmit ]);

  useEffect(() => {
    if (
      subInfo &&
      subInfo?.status !== 'trialing' &&
      !subInfo?.cancel_at_period_end
    ) {
      previewPayment(
        cusId,
        planState.data.selectedPrice.priceId,
        planState.data.quantity,
        subInfo?.id
      );
    } else {
      previewPayment(
        cusId,
        planState.data.selectedPrice.priceId,
        planState.data.quantity,
      );
    }
  }, [ cusObj, team ]);

  useEffect(() => {
    if (planState?.data?.selectedPrice?.amount < currentPlan?.data?.selectedPrice?.amount) {
      setDowngrade(true);
    }
    if (planState?.data?.selectedPrice?.amount === currentPlan?.data?.selectedPrice?.amount) {
      setDowngrade(false);
    }
    if (planState?.data?.selectedPrice?.interval === 'year' && currentPlan?.data?.selectedPrice?.interval === 'month') {
      setDowngrade(false);
    }
    if (planState?.data?.selectedPrice?.interval === 'month' && currentPlan?.data?.selectedPrice?.interval === 'year') {
      setDowngrade(true);
    }
  }, [ planState, currentPlan ]);

  const convertTimestamp = (time: any) => {
    let date: any = new Date(time * 1000);
    date = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    return date;
  };

  useEffect(() => {
    setCurrentPlan({ isLoading: false, data: planState.data });
  }, [ team ]);

  useEffect(() => {
    if (currentPlan?.data?.quantity !== planState?.data?.quantity) {
      if (currentPlan?.data?.selectedPrice?.priceId === planState?.data?.selectedPrice?.priceId) {
        setPlanChanged(true);
      }
    }
    if (currentPlan?.data?.selectedPrice?.priceId !== planState?.data?.selectedPrice?.priceId) {
      if (currentPlan?.data?.quantity === planState?.data?.quantity) {
        setPlanChanged(true);
      }
    } else if (currentPlan?.data?.quantity === planState?.data?.quantity && currentPlan?.data?.selectedPrice?.priceId === planState?.data?.selectedPrice?.priceId) {
      setPlanChanged(false);
    }
  }, [ planState.data, currentPlan.data ]);

  const renewSub = async(sub_id: string) => {
    const renewed = await PaymentsAPI.renewCanceledSub(sub_id);
    if (renewed?.success) {
      history.go(0);
    }
  };

  if (planState.isLoading || currentPlan.isLoading) {
    return (
      <div>
        <CircularProgress style={{ color: '#0E8BFF' }} />
      </div>
    );
  }

  if (team?.attributes?.tier?.includes('none')) {
    return (
      <>
        <div className='plan-mgmt-container'>
          <div className='plan-summary'>
            <div className='plan-summary-header-text'>Summary</div>
            {newPlan === 'none' ? (
              <div className='plan-summary-plan-text'>
                No Plan Active
              </div>
            ) : (
              <div className='plan-summary-plan-text'>
                {newPlan.charAt(0).toUpperCase() + newPlan.slice(1)} Plan{' '}
              </div>
            )}
            {newPlan === 'none' ? (
              <div className='plan-summary-seats-text'></div>
            ) : (
              <div className='plan-summary-seats-text'>
                {planState.data.quantity} seat(s)
              </div>
            )}
          </div>
          <div className='plan-updates-container'>
            <div className='plan-updates-frame'>
              <div className='plan-updates-payment-ovw'>
                {newPlan !== 'none' ? (
                  <div className='plan-updates-price'>
                  $
                    {
                      planState?.data?.selectedPrice?.amount *
                    planState?.data?.quantity
                    }
                  /
                    {planState?.data?.selectedPrice?.interval}
                  </div>
                ) : (
                  <div className='plan-updates-price'></div>
                )}
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='2'
                  height='44'
                  viewBox='0 0 2 44'
                  fill='none'
                >
                  <path d='M1 0V44' stroke='#4A4C51' strokeWidth='2' />
                </svg>
                <div className='plan-updates-right-ovw'>
                  <div className='plan-updates-due-date'></div>
                  <div className='plan-updates-pay-method'>
                    <div className='plan-updates-method-frame'>
                      <div className='plan-updates-card-section'>
                        {!curPaymentMethod.isLoading && curPaymentMethod?.data.id ? (
                          <>
                            {curPaymentMethod.data.type === 'card' && (
                              <>
                                <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
                                  <path d='M22.5 10H2.5M2.5 8.2L2.5 15.8C2.5 16.9201 2.5 17.4802 2.71799 17.908C2.90973 18.2843 3.21569 18.5903 3.59202 18.782C4.01984 19 4.57989 19 5.7 19L19.3 19C20.4201 19 20.9802 19 21.408 18.782C21.7843 18.5903 22.0903 18.2843 22.282 17.908C22.5 17.4802 22.5 16.9201 22.5 15.8V8.2C22.5 7.0799 22.5 6.51984 22.282 6.09202C22.0903 5.7157 21.7843 5.40974 21.408 5.21799C20.9802 5 20.4201 5 19.3 5L5.7 5C4.5799 5 4.01984 5 3.59202 5.21799C3.2157 5.40973 2.90973 5.71569 2.71799 6.09202C2.5 6.51984 2.5 7.07989 2.5 8.2Z' stroke='#EFF1F6' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                                </svg>
                                <div className='plan-updates-card-digits'>
                                  **** {curPaymentMethod?.data.card?.last4}
                                </div>
                                <div className='plan-updates-edit-methods-btn' onClick={() => setPayMode(true)}>
                                  Change payment
                                </div>
                              </>
                            )}
                            {curPaymentMethod.data.type !== 'card' && (
                              <>
                                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                  <path d='M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z' stroke='#EFF1F6' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                                </svg>
                                {curPaymentMethod?.data.us_bank_account ? (
                                  <div className='plan-updates-card-digits'>
                                    **** {curPaymentMethod?.data.us_bank_account?.last4}
                                  </div>
                                ) : (
                                  <div className='plan-updates-card-digits'>
                                    **** bank
                                  </div>
                                )}
                                <div className='plan-updates-edit-methods-btn' onClick={() => setPayMode(true)}>
                                  Change payment
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <div className='plan-updates-edit-methods-btn' onClick={() => setCreateMode(true)}>
                            Add payment
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {newPlan !== 'none' && methods.data.data.length !== 0 ? (
            <div className='plan-upgrade-btn'
              onClick={() => {
                if (!downgrade) {
                  setMgmtOpen({ open: true, action: 'checkout' });
                } else {
                  setConfirmMode(true);
                }
              }
              }
            >
              <div className='plan-upgrade-btn-spacing'>
                <div className='plan-upgrade-btn-text'>
                  Checkout
                </div>
              </div>
            </div>
          ) : (
            <div className='plan-upgrade-btn-disabled'>
              <div className='plan-upgrade-btn-spacing'>
                <div className='plan-upgrade-btn-text'>
                  Checkout
                </div>
              </div>
            </div>
          )}
          <Modal
            open={mgmtOpen.open}
            onClose={() => setMgmtOpen({ open: false, action: 'checkout' })}
          >
            <SubMgmtModal
              activeBtn={activeBtn}
              setPlanUpdating={setPlanUpdating}
              currentPlan={currentPlan}
              downgrade={downgrade}
              cur_user={cur_user}
              createSubscription={createSubscription}
              methods={methods}
              mgmtOpen={mgmtOpen}
              subInfo={subInfo}
              planUpdating={planUpdating}
              cusId={cusId}
              newPlan={newPlan}
              setMgmtOpen={setMgmtOpen}
              cusObj={cusObj}
              planState={planState}
              changePlan={changePlan}
            />
          </Modal>
          <Modal
            open={payMode}
            onClose={() => setPayMode(false)}
          >
            <PayMethodOptionsModal
              handleTabChange={handleTabChange}
              cusId={cusId}
              subInfo={subInfo}
              methods={methods}
              curPaymentMethod={curPaymentMethod}
              setPayMode={setPayMode}
            />
          </Modal>
          <Modal
            open={createMode}
            onClose={() => setCreateMode(false)}
          >
            <CreatePaymentModal
              cusId={cusId}
              setCreateMode={setCreateMode}
              paymentSubmit={paymentSubmit}
              setPaymentSubmit={setPaymentSubmit}
            />
          </Modal>
        </div>
      </>
    );
  }

  return (
    <>
      {subInfo.schedule && (
        <DowngradeNotice subInfo={subInfo} />
      )}
      <div className='plan-mgmt-container'>
        <div className='plan-summary'>
          <div className='plan-summary-header-text'>Summary</div>
          <div className='plan-summary-plan-text'>
            {newPlan.charAt(0).toUpperCase() + newPlan.slice(1)} Plan{' '}
          </div>
          <div className='plan-summary-seats-text'>
            {planState.data.quantity} seat(s)
          </div>
        </div>
        <div className='plan-updates-container'>
          <div className='plan-updates-frame'>
            <div className='plan-updates-payment-ovw'>
              {!planState.isLoading && !planChanged ? (
                <>
                  {!incomingChanges.isLoading ? (
                    <div className='plan-updates-price'>
                        $
                      {(incomingChanges?.data?.amount_due / 100).toFixed(2)}
                        /{planState?.data?.selectedPrice?.interval}
                    </div>
                  ) : (
                    <div>
                      <CircularProgress style={{ color: '#0E8BFF' }} />
                    </div>
                  )}
                </>
              ) : (
                <div className='plan-updates-price'>
                    $
                  {
                    planState?.data?.selectedPrice?.amount *
                      planState?.data?.quantity
                  }
                    /
                  {planState?.data?.selectedPrice?.interval}
                </div>
              )}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='2'
                height='44'
                viewBox='0 0 2 44'
                fill='none'
              >
                <path d='M1 0V44' stroke='#4A4C51' strokeWidth='2' />
              </svg>
              <div className='plan-updates-right-ovw'>
                <div className='plan-updates-due-date'>
                  <div className='plan-updates-date-content'>
                    {subInfo?.status === 'trialing' ? (
                      <div className='payment-due-text'>Free trial ends on</div>
                    ) : (
                      <>
                        {subInfo?.cancel_at_period_end ? (
                          <div className='payment-due-text'>Current plan cancels on</div>
                        ) : (
                          <div className='payment-due-text'>Next Payment Due</div>
                        )}
                      </>
                    )}
                    <div className='payment-date-text'>
                      {convertTimestamp(
                        subInfo?.current_period_end,
                      )}
                    </div>
                  </div>
                </div>
                <div className='plan-updates-pay-method'>
                  <div className='plan-updates-method-frame'>
                    <div className='plan-updates-card-section'>
                      {!curPaymentMethod.isLoading && curPaymentMethod?.data.id ? (
                        <>
                          {curPaymentMethod.data.type === 'card' && (
                            <>
                              <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
                                <path d='M22.5 10H2.5M2.5 8.2L2.5 15.8C2.5 16.9201 2.5 17.4802 2.71799 17.908C2.90973 18.2843 3.21569 18.5903 3.59202 18.782C4.01984 19 4.57989 19 5.7 19L19.3 19C20.4201 19 20.9802 19 21.408 18.782C21.7843 18.5903 22.0903 18.2843 22.282 17.908C22.5 17.4802 22.5 16.9201 22.5 15.8V8.2C22.5 7.0799 22.5 6.51984 22.282 6.09202C22.0903 5.7157 21.7843 5.40974 21.408 5.21799C20.9802 5 20.4201 5 19.3 5L5.7 5C4.5799 5 4.01984 5 3.59202 5.21799C3.2157 5.40973 2.90973 5.71569 2.71799 6.09202C2.5 6.51984 2.5 7.07989 2.5 8.2Z' stroke='#EFF1F6' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                              </svg>
                              <div className='plan-updates-card-digits'>
                                **** {curPaymentMethod?.data.card?.last4}
                              </div>
                              <div className='plan-updates-edit-methods-btn' onClick={() => setPayMode(true)}>
                                Change payment
                              </div>
                            </>
                          )}
                          {curPaymentMethod.data.type !== 'card' && (
                            <>
                              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <path d='M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z' stroke='#EFF1F6' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                              </svg>
                              {curPaymentMethod?.data.us_bank_account ? (
                                <div className='plan-updates-card-digits'>
                                  **** {curPaymentMethod?.data.us_bank_account?.last4}
                                </div>
                              ) : (
                                <div className='plan-updates-card-digits'>
                                  **** bank
                                </div>
                              )}
                              <div className='plan-updates-edit-methods-btn' onClick={() => setPayMode(true)}>
                                Change payment
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <div className='plan-updates-edit-methods-btn' onClick={() => setCreateMode(true)}>
                          Add payment
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {subInfo?.status === 'trialing' && subInfo?.cancel_at_period_end && (
          <>
            {newPlan !== 'none' && curPaymentMethod?.data?.id ? (
              <div
                className='plan-upgrade-btn'
                onClick={() => setMgmtOpen({ open: true, action: 'checkout' })}
              >
                <div className='plan-upgrade-btn-spacing'>
                  <div className='plan-upgrade-btn-text'>
                    Checkout
                  </div>
                </div>
              </div>
            ) : (
              <div className='plan-upgrade-btn-disabled'>
                <div className='plan-upgrade-btn-spacing'>
                  <div className='plan-upgrade-btn-text'>
                    Checkout
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {subInfo?.status !== 'trialing' && (
          <>
            {/* if downgrade scheduled, allow no changes */}
            {subInfo.schedule ? (
              <div className='plan-upgrade-btn-disabled'>
                <div className='plan-upgrade-btn-spacing'>
                  <div className='plan-upgrade-btn-text-disabled'>
                    Update
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* no changes made, disable update button */}
                {!planChanged && !subInfo?.cancel_at_period_end && (
                  <div className='plan-upgrade-btn-disabled'>
                    <div className='plan-upgrade-btn-spacing'>
                      <div className='plan-upgrade-btn-text-disabled'>
                        Update
                      </div>
                    </div>
                  </div>
                )}
                {/* plan changed, allow update (even if current plan set to cancel) */}
                {planChanged && (
                  <div
                    className='plan-upgrade-btn'
                    onClick={() => {
                      if (!downgrade) {
                        setMgmtOpen({ open: true, action: 'update' });
                      } else {
                        setConfirmMode(true);
                      }
                    }
                    }
                  >
                    <div className='plan-upgrade-btn-spacing'>
                      <div className='plan-upgrade-btn-text'>
                        Update
                      </div>
                    </div>
                  </div>
                )}
                {/* no changes made, allow user to renew a canceled plan */}
                {!planChanged && subInfo?.cancel_at_period_end && (
                  <div className='plan-upgrade-btn' onClick={() => setRenewMode(true)}>
                    <div className='plan-upgrade-btn-spacing'>
                      <div className='plan-upgrade-btn-text'>
                        Renew
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        <Modal
          open={confirmMode}
          onClose={() => setConfirmMode(false)}
        >
          <ConfirmDowngradeModal
            setMgmtOpen={setMgmtOpen}
            setConfirmMode={setConfirmMode}
          />
        </Modal>
        <Modal
          open={mgmtOpen.open}
          onClose={() => setMgmtOpen({ open: true, action: 'update' })}
        >
          <SubMgmtModal activeBtn={activeBtn} setPlanUpdating={setPlanUpdating} currentPlan={currentPlan} downgrade={downgrade} cur_user={cur_user} createSubscription={createSubscription} methods={methods} mgmtOpen={mgmtOpen} subInfo={subInfo} planUpdating={planUpdating} cusId={cusId} newPlan={newPlan} setMgmtOpen={setMgmtOpen} cusObj={cusObj} planState={planState} changePlan={changePlan} />
        </Modal>
        <Modal
          open={renewMode}
          onClose={() => setRenewMode(false)}
        >
          <RenewPlanModal renewSub={renewSub} subInfo={subInfo} setRenewMode={setRenewMode} />
        </Modal>
        <Modal
          open={createMode}
          onClose={() => setCreateMode(false)}
        >
          <CreatePaymentModal
            cusId={cusId}
            setCreateMode={setCreateMode}
            paymentSubmit={paymentSubmit}
            setPaymentSubmit={setPaymentSubmit}
          />
        </Modal>
        <Modal
          open={payMode}
          onClose={() => setPayMode(false)}
        >
          <PayMethodOptionsModal handleTabChange={handleTabChange} cusId={cusId} subInfo={subInfo} methods={methods} curPaymentMethod={curPaymentMethod} setPayMode={setPayMode} />
        </Modal>
      </div>
    </>
  );
};

export default PlanManagement;
